<template>
  <div class="dashboard__dashboardrequestlist">
    <div class="dashboard__dashboardrequestlist--header">
      <h1>Request List</h1>
      <router-link :to="{ name: 'RequestList', params: { type: 'rfq' }}">See All</router-link>
    </div>
    <div class="dashboard__dashboardrequestlist--contentlist" v-if="rfqItems">
      <div 
        class="dashboard__dashboardrequestlist--content"
        v-for="(items) in rfqItems.data"
        :key="items.rfqnumber"
        style="border-bottom: 1px solid #E8EBEE"
      >
        <div class="dashboard__dashboardrequestlist--contentleft">
          <img :src="getImageShipment(items.service_head)" alt="" width="32" height="32">
          <div class="dashboard__dashboardrequestlist--shipmentdetails">
            <h2 v-if="items.service_head === 'LAND'">{{ items.cityf }} ({{ items.city_from }}) to {{ items.cityt }} ({{ items.city_to }})</h2>
            <h2 v-else>{{ items.cityf }} ({{ items.country_from }}) to {{ items.cityt }} ({{ items.country_to }})</h2>
            <p>{{ items.rfqnumber }} | {{ items.service_head === 'LAND' ? formatShipmentType(items.service_head) : formatShipmentType(items.shipment_type) }}</p>
          </div>
        </div>
        <button @click="duplicateRfq(items)">Duplicate RFQ</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RequestList',
  data () {
    return {
      list: [
        { row1: 'Jakarta (IDN) to Hamburg (DEU)', row2: 'RFQ/2023062800001673 | FCL' },
        { row1: 'Kota b', row2: 'test' },
        { row1: 'Kota c', row2: 'test' },
        { row1: 'Kota d', row2: 'test' },
        { row1: 'Kota e', row2: 'test' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      rfqItems: 'rfq/items',
      isLoadingRfq: 'rfq/isLoading',
      errorRfq: 'rfq/error'
    })
  },
  mounted () {
    this.fetchRFQList()
  },
  methods: {
    getImageShipment (type) {
      if (type === 'OCEAN') {
        return require('@/assets/image/icon/shipment-ocean-color.svg')
      } else if (type === 'LAND') {
        return require('@/assets/image/icon/shipment-land-color.svg')
      }
      return require('@/assets/image/icon/shipment-air-color.svg')
    },

    async fetchRFQList () {
      await this.$store.dispatch('rfq/FETCH_RFQ', {
        type: 'ongoing', currentPage: 1, perPage: 5
      })
    },

    duplicateRfq (data) {
      if (data.service_head === 'LAND') {
        this.$eventHub.$emit('duplicate-land', data.id)
        this.$router.push({ name: 'RequestShipment', params: { step: 'type-shipment' }, query: { mode: 'LAND' } })
      } else if (data.service_head === 'AIR') {
        this.$eventHub.$emit('duplicate-air', data.id)
        this.$router.push({ name: 'RequestShipment', params: { step: 'type-shipment' }, query: { mode: 'AIR' } })
      } else if (data.service_head === 'OCEAN') {
        this.$eventHub.$emit('duplicate-ocean', data.id)
        this.$router.push({ name: 'RequestShipment', params: { step: 'type-shipment' }, query: { mode: 'OCEAN' } })
      }
    },

    formatShipmentType (data) {
      const upperCaseData = data.toUpperCase()
      if (upperCaseData === 'AIRCOURIER') {
        return 'Air Courier'
      } else if (upperCaseData === 'AIRCARGO') {
        return 'Air Cargo'
      } else if (upperCaseData === 'AIRBREAKBULK') {
        return 'Air Breakbulk'
      } else if (upperCaseData.includes('FCL') || upperCaseData.includes('LCL')) {
        return upperCaseData.substring(3)
      } else if (upperCaseData === 'OCEANBREAKBULK' || upperCaseData === 'SEABREAKBULK') {
        return 'Ocean Breakbulk'
      } else if (upperCaseData === 'LAND') {
        return 'Land'
      } else if (upperCaseData === 'BARGE') {
        return 'Barge'
      } else {
        return data
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/RequestList.vue